var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inner-loading"},[_vm._t("default"),(_vm.loading)?_c('div',{staticClass:"inner-loading__overlay"},[_c('spring-spinner',{attrs:{"animation-duration":2000,"size":48,"color":_vm.$themes.primary}})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }